module.exports = __webpack_public_path__ + "static/media/landing-bg.9141455f.jpg";